export default {
  operatedBy: 'Von',
  partlyOperatedBy: 'Teilweise von',
  operatedByGerman: ' betrieben',
}
